<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Kj40lw/tc-custom/9781452165578.jpg?1737753211525" alt="This image is the cover for the book City Walks: New York, City Walks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">City Walks: New York, City Walks
      </h1>
      <p class="bookDescription body article font2">
        <b>This city was made for walking—navigate the sidewalks of New York with this updated guide.</b><br/><br/>Featuring brand-new walks, neighborhoods, restaurants, shops, and more, this revised guide reveals New York’s best-kept secrets as well as its best-known landmarks, from the Brooklyn Bridge to the High Line to the new Freedom Tower. <br/><br/>Each of the fifty tours includes a full-color map, walking directions, and highlighted stopping points. It’s ideal for anyone who wants to make the most of NYC—be it transplant, traveler, or native.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henry de Tessan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b49a3ee